import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { getTopLevelTopics, type TopLevelTopicDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useTopics(): UseQueryResult<TopLevelTopicDto[], AxiosError> {
    const queryKey = useMemo(() => queryKeys.topics(), []);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getTopLevelTopics({ signal }).then((result) => result.data),
    });
}
